import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	totalBalance: 0,
	purchaseChart: {
		info: {
			totalAF: 0,
			totalLease: 0,
			approvedLease: 0,
			approvedAF: 0,
			rejectedLease: 0,
			rejectedAF: 0,
			Approved: 0,
			Rejected: 0,
		},
		totalValue: { chart1: 0, chart2: 0 },
	},
	deliveryChart: {
		info: { successful: 0, delayed: 0, not_Delivered: 0, door_step: 0, pick_up: 0 },
		totalValue: { chart1: 0, chart2: 0 },
	},
	currentTab: "",
	currentFilter: "lease",
	tableData: [{}],
};

export const LogisticSlice = createSlice({
	name: "logistics",
	initialState,
	reducers: {
		setPurchaseChart: (state, action) => {
			state.purchaseChart = action.payload;
		},

		setDeliveryChart: (state, action) => {
			state.deliveryChart = action.payload;
		},

		setTotalBalance: (state, action) => {
			state.totalBalance = action.payload;
		},
		setCurrentTab: (state, action) => {
			state.currentTab = action.payload;
		},
		setCurrentFilter: (state, action) => {
			state.currentFilter = action.payload;
		},
		setTableData: (state, action) => {
			state.tableData = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	setPurchaseChart,
	setDeliveryChart,
	setTotalBalance,
	setCurrentTab,
	setCurrentFilter,
	setTableData,
} = LogisticSlice.actions;

export default LogisticSlice.reducer;
